import { ICellRendererParams } from 'ag-grid-community';

export function getRowNumber<TData>(params: ICellRendererParams<TData>) {
	return params.rowIndex + 1;
}
